export enum BulkType {

  Chases = 1,
  Pends = 2,
  Addresses = 3,
  Documents = 4,
}
